import { apiClient } from "@/shared/api/client";
import type {
  Timesheet,
  TimesheetBulkApproveResult,
  TimesheetDisputePayload,
  TimesheetStatus,
} from "@/features/timesheets/types";

export async function listVenueTimesheets(status?: TimesheetStatus): Promise<Timesheet[]> {
  const { data } = await apiClient.get<Timesheet[]>("/timesheets/venue", {
    params: status ? { status } : undefined,
  });
  return data;
}

export async function listMyTimesheets(): Promise<Timesheet[]> {
  const { data } = await apiClient.get<Timesheet[]>("/timesheets/me");
  return data;
}

export async function getTimesheet(id: string): Promise<Timesheet> {
  const { data } = await apiClient.get<Timesheet>(`/timesheets/${id}`);
  return data;
}

export async function approveTimesheet(id: string): Promise<Timesheet> {
  const { data } = await apiClient.post<Timesheet>(`/timesheets/${id}/approve`);
  return data;
}

export async function disputeTimesheet(
  id: string,
  payload: TimesheetDisputePayload,
): Promise<Timesheet> {
  const { data } = await apiClient.post<Timesheet>(`/timesheets/${id}/dispute`, payload);
  return data;
}

export async function bulkApproveTimesheets(ids: string[]): Promise<TimesheetBulkApproveResult> {
  const { data } = await apiClient.post<TimesheetBulkApproveResult>("/timesheets/bulk-approve", {
    timesheet_ids: ids,
  });
  return data;
}

export async function manualCheckOut(shiftId: string): Promise<{ id: string }> {
  const { data } = await apiClient.post<{ id: string }>(`/shifts/${shiftId}/manual-checkout`);
  return data;
}
